import React from 'react';
import PelhamH from '../assets/images/pelham-h.png';

class Home extends React.Component {
  render() {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#000',
        }}
      >
        <img
          src={PelhamH}
          alt="Pelham"
          style={{ width: 96, height: 'auto', display: 'block', imageRendering: 'auto' }}
        />
      </div>
    );
  }
}

export default Home;
